const tableOption = function () {
  return {
    stripe: true,
    page: true,
    maxHeight: "98%",
    align: "center",
    header: false,
    index: true,
    selection: true,
    emptyText: "暂无数据",
    column: [
      {
        label: "区域电网名称",
        prop: "areaPowerName",
        search: true,
        clearable: true,
      },
      {
        label: "排放因子值(kgCO2/kWh)",
        prop: "emissionFactor",
      },
      {
        label: "覆盖省份",
        prop: "provinces",
      },
      {
        label: "年份",
        prop: "powerYear",
      },
      {
        label: "备注",
        prop: "powerRemark",
      }
    ]
  };
};

export default tableOption;
